import { useMemo } from 'react';
import { makeClassName } from '@siteless/util';
import AllUserProfilesResource from '../resources/AllUserProfiles';
import BallotsCompletedResource from '../resources/Ballot/Completed';
import { CurrentUserMustResource } from '../resources/Auth/CurrentUserMust';
import avatars from '../config/avatars';
import LetterboxdIcon from './LetterboxdIcon';
import CrownIcon from './CrownIcon';
import { Virtuoso } from 'react-virtuoso';

const PreScoringUserList = ({
  filterToUserIds,
  ownerUserId,
  onSelectBallot,
  className,
}: {
  filterToUserIds?: string[] | null;
  ownerUserId?: string;
  onSelectBallot?: (ballotKey: string) => void;
  className?: string;
}) => {
  let currentUser = CurrentUserMustResource.use();
  let [allUserProfiles] = AllUserProfilesResource.useLoadable();
  let completed = BallotsCompletedResource.use();

  let userIds = useMemo(() => {
    return Object.entries(completed)
      .filter(([, isCompleted]) => Boolean(isCompleted))
      .map(([userId]) => userId)
      .filter((userId) => allUserProfiles?.users?.[userId])
      .filter((userId) => !filterToUserIds || filterToUserIds.includes(userId))
      .sort((a, b) => {
        if (a === currentUser.id) return -1;
        if (b === currentUser.id) return 1;
        return (allUserProfiles?.users?.[a]?.handle || '').localeCompare(
          allUserProfiles?.users?.[b]?.handle || '',
        );
      });
  }, [completed, allUserProfiles, filterToUserIds, currentUser.id]);

  return (
    <Virtuoso
      className={className}
      style={{ height: '100%' }}
      data={userIds}
      components={{
        Header: () => <div className="h-24" />,
        Footer: () => <div className="h-16" />,
      }}
      itemContent={(index, userId) => {
        let user = allUserProfiles?.users?.[userId];
        if (!user) return null;

        let ArtworkComponent =
          avatars[user.avatarId || 'AVATAR_0'].ArtworkComponent;

        return (
          <div
            className={makeClassName(
              'relative z-10 mx-auto flex w-40 flex-col items-center justify-center pb-6',
              index % 2 ? '-right-12' : '-left-12',
              userId === currentUser.id && '--current-user',
            )}
            onClick={() => onSelectBallot?.(userId)}
          >
            <div>
              <ArtworkComponent
                className="h-24 w-24 shadow-md"
                backgroundColor={user.avatarBackgroundHex || undefined}
              />
            </div>
            <div className="__handle mt-2 max-w-[208px] truncate px-2 text-center">
              {user.handle}
              {ownerUserId === userId && (
                <CrownIcon className="ml-1 inline-block h-4 w-4 text-purple-400" />
              )}
              {user.letterboxdId && (
                <LetterboxdIcon className="ml-1 inline-block h-4 w-4 text-purple-400" />
              )}
            </div>
          </div>
        );
      }}
    />
  );
};

export default PreScoringUserList;
